import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";

type InputGroupProps = {
  merge?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'InputGroup',
  props: {
    merge: { type: Boolean }
  },
  setup(__props: any) {

const inputGroupClass = {
  normal: "input-group",
  merge: "input-group-merge",
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["has-validation input-group", { 'input-group-merge': _ctx.merge }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})